import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CrearEditarCodigosDispositivosComponent } from '../../standalone/codigos-dispositivos/crear-editar-codigos-dispositivos/crear-editar-codigos-dispositivos.component';
import { ListadoCodigosDispositivoComponent } from '../../standalone/codigos-dispositivos/listado-codigos-dispositivos/listado-codigos-dispositivos.component';
import { ListadoModelosDispositivosComponent } from '../../standalone/modelos-dispositivos/listado-modelos-dispositivos/listado-modelos-dispositivos.component';
import { CrearEditarModeloDispositivoComponent } from '../../standalone/modelos-dispositivos/crear-editar-modelo-dispositivo/crear-editar-modelo-dispositivo.component';
import { ListadoConfigPerfilComponent } from '../../standalone/config-perfil/listado-config-perfil/listado-config-perfil.component';
import { CrearEditarConfigPerfilComponent } from '../../standalone/config-perfil/crear-editar-config-perfil/crear-editar-config-perfil.component';
import { ListadoMarkersComponent } from './vehiculos/listado-markers/listado-markers.component';

const routes: Routes = [
  // Codigos Dispositivos
  {
    path: 'codigosDispositivos/:tipo',
    title: 'Códigos de dispositivos',
    component: ListadoCodigosDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/crear',
    title: 'Nuevo código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'codigosDispositivos/:tipo/editar/:id',
    title: 'Editar código',
    component: CrearEditarCodigosDispositivosComponent,
    canActivate: [],
  },
  // Modelos Dispositivos
  {
    path: 'modelosDispositivos/:tipo',
    title: 'Modelos de dispositivos',
    component: ListadoModelosDispositivosComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/crear',
    title: 'Nuevo modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },
  {
    path: 'modelosDispositivos/:tipo/editar/:id',
    title: 'Editar modelo',
    component: CrearEditarModeloDispositivoComponent,
    canActivate: [],
  },

  //Config Perfiles
  {
    path: 'configsPerfiles/:tipo',
    title: 'Configuración de perfiles',
    component: ListadoConfigPerfilComponent,
    canActivate: [],
  },
  {
    path: 'configsPerfiles/:tipo/crear',
    title: 'Nuevo perfil',
    component: CrearEditarConfigPerfilComponent,
    canActivate: [],
  },
  {
    path: 'configsPerfiles/:tipo/editar/:id',
    title: 'Editar perfil',
    component: CrearEditarConfigPerfilComponent,
    canActivate: [],
  },

  // Vehículos
  {
    path: 'markersVehiculos',
    title: 'Íconos de vehículos',
    component: ListadoMarkersComponent,
    canActivate: [],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ConfiguracionRoutingModule {}
